import React from 'react';
import './styles.scss';
import { translate } from '@utils/i18n';
const namespace = 'features.custom_banner';
export function CustomBanner() {
    return (React.createElement("div", { className: "custom-banner" },
        React.createElement("div", { className: "custom-banner__content" },
            React.createElement("i", { className: "fa-light fa-circle-exclamation custom-banner__alert-icon" }),
            React.createElement("span", null, translate('inspections_with_unresolved_issues_cannot_be_marked_complete', {
                namespace
            })))));
}
export default CustomBanner;
